import { useEffect, useState } from 'react';
import { useParams } from 'react-router';

import { useRouteQuery } from 'route/hooks/useRouteQuery';

import { TrainingUpdateDrawerContent } from './TrainingUpdateDrawerContent';

interface IProps {
    open?: boolean;
    trainingId?: string;
    onClose?(): void;
}

export const TrainingUpdateDrawer = ({ open, trainingId, onClose }: IProps) => {
    const routeQuery = useRouteQuery();
    const { trainingId: routeTrainingId } = useParams();

    const currentTrainingId =
        trainingId || routeQuery.get('id') || routeTrainingId;

    // Retain the last opened id so the drawer keeps its content while
    // animating out after the id is removed from the url.
    const [lastTrainingId, setLastTrainingId] = useState<string>();

    useEffect(() => {
        if (open && currentTrainingId) setLastTrainingId(currentTrainingId);
    }, [open, currentTrainingId]);

    const id = open ? currentTrainingId : lastTrainingId;

    return (
        <TrainingUpdateDrawerContent
            id={id || undefined}
            open={open && !!id}
            onClose={onClose}
        />
    );
};
